import React, { useState, useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";
import * as TipoDeError from "../../isp._comun/services/Errores";

import {
    NotificacionToast,
    NotificacionToastDeCreacion,
    // NotificacionToastDeError,
} from "../../isp._comun/iu/componentes/widgets/notificacionesToast/NotificacionesToast";

// import DataDeRespuestas_De_Zona from "./layouts/DataEstaticaDeRespuestas.json";
import {DataEstaticaDeRespuesta} from './layouts/žconstantesIuLayoutZonas'

import QueryZonaReducer from "../reductores/QueryZonaReducer";
import CargaDeZonasBuscados from "../reductores/acciones/dispatch/CargaDeZonasBuscados";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";
import * as Action from "../reductores/acciones/dispatch/_ActionsDispatch";

import DialogoQueryZonasLayout from "./layouts/DialogoQueryZonasLayout";
import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";
import ServiceRegistroDeZona from "../../isp.žapi.zonas/ServiceRegistroDeZona";
import ServiceQueryZonas from "../../isp.žapi.zonas/ServiceQueryZonas";
import ServiceActualizacionDeZona from "../../isp.žapi.zonas/ServiceActualizacionDeZona";
import ServiceEliminacionDeZona from "../../isp.žapi.zonas/ServiceEliminacionDeZona";

const DialogoQueryZonas = ({ ventana }) => {
    const { notificar, handleErroresExtraEnPrincipal } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryZonaReducer, {
        output: {
            domain: {
                resultSet: [
                    // {idZona:"1",nombre:"Santa Rosa"},
                    // {idZona:"2",nombre:"Pueblo 01"},
                    // {idZona:"3",nombre:"Pueblo San Juan"},
                ],
            },
        },
        input: {
            domain: {
                nombre: "",
                rowSelected: null,
                indexRowSelected: null,
                forceUpdate: false,
                // idZonaSelected: null,
            },
        },
        error: {
            nomBlanc: false,
            // nomMF: false,
        },
        flag: {
            procesandoComando: true,
            procesandoComandoBuscarAll: true,
            procesandoComandoCrear: false,
            procesandoComandoUpdate: false,
            procesandoComandoEliminar: false,
            sensorMostrarFinalTabla: false,
            // procesandoComandoBuscar: false,
        },
    });

    const ServiceApiRegistrarZona = new ServiceRegistroDeZona();
    const registrarZonaCommand = new ComandoAPI(ServiceApiRegistrarZona);
    registrarZonaCommand.ejecutar = async () => {
        const zona = {
            // tipoZona: estadoQ.domain.screen.tipoZona,
            nombre: estadoQ.input.domain.nombre,
            // descripcion: estadoQ.domain.screen.descripcion,
            // precio: estadoQ.domain.screen.precio,
            // moneda: estadoQ.domain.screen.moneda,
            // udm: estadoQ.domain.screen.udm,
        };

        try {
            const dataRegistradaDeZona = await ServiceApiRegistrarZona.ejecutar(zona);

            dispatchQ(new Action.CargaDeZonaRegistrado(dataRegistradaDeZona));
            notificar(
                new NotificacionToast(
                    DataEstaticaDeRespuesta.CreacionZona.titulo,
                    DataEstaticaDeRespuesta.CreacionZona.mensaje + dataRegistradaDeZona.nombre,
                    DataEstaticaDeRespuesta.CreacionZona.nivel
                )
            );
            
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchQ(new Action.CargaDeErroresDelDominioAlCrearZona(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorEntidadDuplicada) {
                dispatchQ(new Action.FinalizarComando());
                notificar(
                    new NotificacionToast(
                        DataEstaticaDeRespuesta.ZonaDuplicada.titulo,
                        DataEstaticaDeRespuesta.ZonaDuplicada.mensaje + zona.nombre,
                        DataEstaticaDeRespuesta.ZonaDuplicada.nivel
                    )
                );
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new Action.FinalizarComando());
            }

            handleErroresExtraEnPrincipal(error);
        }
    };

    const ServiceApiActualizacionDeZona = new ServiceActualizacionDeZona();
    const actualizarZonaCommand = new ComandoAPI(ServiceApiActualizacionDeZona);
    actualizarZonaCommand.ejecutar = async () => {
        const requestActualizar = {
            zona: {
                idZona: estadoQ.input.domain.rowSelected.idZona,
                data: { nombre: estadoQ.input.domain.nombre },
            },
            forceUpdate: estadoQ.input.domain.forceUpdate,
        };

        try {
            await ServiceApiActualizacionDeZona.ejecutar(requestActualizar);
            dispatchQ(
                new Action.CargaDeZonaActualizado()
                // new Action.CargaDeClienteActualizado(dataDeClienteActualizado)
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarZona(error.data));
                return;
            }
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarZona(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new Action.FinalizarComando());
            }

            handleErroresExtraEnPrincipal(error);
        }
    };

    const ServiceApiQueryZonas = new ServiceQueryZonas();
    const buscarZonasCommand = new ComandoAPI(ServiceApiQueryZonas);
    buscarZonasCommand.ejecutar = async (paramsQuery) => {
        try {
            /* dispatchQ(new CargaDeZonasBuscados([
                {idZona:"1",nombre:"Santa Rosa",estado:"hab"},
                {idZona:"2",nombre:"Pueblo 01",estado:"hab"},
                {idZona:"3",nombre:"Pueblo San Juan",estado:"hab"},
            ])); */
            const respuestaQuery = await ServiceApiQueryZonas.ejecutar(paramsQuery);
            dispatchQ(new CargaDeZonasBuscados(respuestaQuery.zonas));
        } catch (error) {
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };

    const ServiceApiEliminacionDeZona = new ServiceEliminacionDeZona();
    const eliminarZonaCommand = new ComandoAPI(ServiceApiEliminacionDeZona);
    eliminarZonaCommand.ejecutar = async (paramsQuery) => {
        try {
            const respuestaQuery = await ServiceApiEliminacionDeZona.ejecutar(paramsQuery);
            dispatchQ(new CargaDeZonasBuscados(respuestaQuery.zonas));
        } catch (error) {
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };

    return (
        <DialogoQueryZonasLayout
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarZonasCommand={buscarZonasCommand}
            registrarZonaCommand={registrarZonaCommand}
            actualizarZonaCommand={actualizarZonaCommand}
            eliminarZonaCommand={eliminarZonaCommand}
        />
    );
};

export default DialogoQueryZonas;
